import {
    Exercise,
    LabelBody,
    LabelDisplay2,
    LabelHeader5,
    ProgressBar,
    SecondaryButton,
    Spacer,
    SwirlyBox,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { Module7Exercise1Illustration1 } from '../../icons';
import { ExerciseStatus } from '../../interfaces';

export const exerciseData310: ExerciseData = {
    ExerciseView: Module3Exercise1DetailsView,
    dataKeys: [],
    questions: [],
};

function Module3Exercise1DetailsView({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    return (
        <Exercise title="Energipyramiden">
            <ProgressBar current={exercise.CurrentPage} total={10} />
            <Page1
                onContinue={() => {
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: '3.1.1',
                    });
                }}
            />
        </Exercise>
    );
}

type PageProps = { onContinue: () => void };
function Page1({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2>Energipyramiden</LabelDisplay2>
            <LabelBody className="mb-20 mt-10">
                I en presset periode kan det give mening at se nærmere på,
                hvordan du bruger og skaber energi. Man kan opdele energi i tre
                forskellige typer:
            </LabelBody>
            <Module7Exercise1Illustration1 className="mx-auto my-30" />
            <LabelBody className="mt-20">
                Selvom de forskellige energityper er adskilte, så påvirker de og
                bygger oven på hinanden. Den fysiske energi er fundamentet for
                resten af energipyramiden. Hvis du har nogenlunde fysisk energi
                kan det være nemmere at være følelsesmæssigt balanceret og
                mentalt fokuseret. Samtidig kan du også have en god fysisk
                energi, men være følelsesmæssigt ude af balance og derfor have
                svært ved at have mentalt fokus.
            </LabelBody>
            <LabelHeader5 class="mt-20">
                Hvordan arbejder vi med energi?
            </LabelHeader5>
            <LabelBody className="mb-20 mt-10">
                I øvelsen bliver du introduceret til de forskellige energityper
                og bedt om at give dig selv en energiscore fra 1-4 for hver type
                energi. Det vil give dig en idé om, hvor du med fordel kunne
                starte med at arbejde med din energi. Det har vi nogle gode råd
                til.
            </LabelBody>
            <SwirlyBox class="mb-20">
                Er du klar til at se på din energi?
            </SwirlyBox>
            <Spacer />
            <SecondaryButton onClick={onContinue}>
                Lad mig komme i gang
            </SecondaryButton>
        </>
    );
}
